import { TRIP_STEPS } from './types';
import type { Trip, TripRisk, Vehicle } from './types';

/** Bước cuối (Xong). */
export const LAST_STEP = TRIP_STEPS.length - 1;

export const isDone = (trip: Pick<Trip, 'step'>): boolean => trip.step >= LAST_STEP;

/** Tên bước đang làm; chuyến đã xong trả "Xong". */
export function stepLabel(step: number): string {
  return TRIP_STEPS[Math.min(Math.max(step, 0), LAST_STEP)]!;
}

/** Sang bước kế tiếp; null nếu đã xong. Không nhảy cóc (tài xế xác nhận từng bước). */
export function advance(trip: Trip): Trip | null {
  if (isDone(trip)) return null;
  const step = trip.step + 1;
  return { ...trip, step, risk: step >= LAST_STEP ? 'done' : trip.risk };
}

/** Lùi một bước (Hoàn tác của toast); không lùi dưới 0. */
export function undo(trip: Trip, prevRisk: TripRisk): Trip {
  const step = Math.max(trip.step - 1, 0);
  return { ...trip, step, risk: step >= LAST_STEP ? 'done' : prevRisk === 'done' ? 'ok' : prevRisk };
}

export type TripFilter = 'all' | 'run' | 'risk' | 'done';

const FILTERS: Record<TripFilter, (t: Trip) => boolean> = {
  all: () => true,
  run: (t) => t.step > 0 && t.step < LAST_STEP,
  risk: (t) => t.risk === 'p0' || t.risk === 'late',
  done: isDone,
};

export const filterTrips = (trips: readonly Trip[], f: TripFilter): Trip[] => trips.filter(FILTERS[f]);

export const tripCounts = (trips: readonly Trip[]): Record<TripFilter, number> => ({
  all: trips.length,
  run: filterTrips(trips, 'run').length,
  risk: filterTrips(trips, 'risk').length,
  done: filterTrips(trips, 'done').length,
});

/** Xe có gán được lệnh không: khoá kỹ thuật thì không. */
export const canAssign = (v: Pick<Vehicle, 'locked'>): boolean => !v.locked;
